import BeforeAfterGallery from './BeforeAfterSlider';

interface HeroProps {
  scrollToForm: () => void;
}

export default function Hero({ scrollToForm }: HeroProps) {
  return (
    <section className="relative bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16 xl:py-24">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-6 sm:space-y-8">
            {/* Badge */}
            <div className="inline-block">
              <span className="bg-gradient-to-r from-[#E91E63] to-[#C2185B] text-white text-sm sm:text-base font-bold px-6 py-2.5 rounded-full shadow-lg inline-flex items-center gap-2">
                <i className="ri-medal-fill text-xl text-yellow-300"></i>
                O Melhor Laser do Mundo
              </span>
            </div>
            
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black leading-tight">
              Depilação a Laser em Americana com Resultados Reais e Redução Definitiva dos Pelos
            </h1>
            
            <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
              Tecnologia avançada e segura, com resultados visíveis desde as primeiras sessões.
            </p>

            {/* Benefits List */}
            <div className="space-y-4">
              {[
                'Redução progressiva e duradoura dos pelos',
                'Procedimento rápido, confortável e seguro',
                'Adeus pelos encravados, foliculite e irritações',
                'Mais liberdade, praticidade e autoestima no dia a dia'
              ].map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 bg-[#E91E63] rounded-full mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <p className="text-base sm:text-lg text-black">{benefit}</p>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <div className="space-y-3">
              <button 
                onClick={scrollToForm}
                className="bg-[#E91E63] hover:bg-[#C2185B] text-white font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 md:px-10 py-3.5 sm:py-4 md:py-5 rounded-2xl transition-all duration-300 hover:scale-105 shadow-xl shadow-[#E91E63]/40 w-full sm:w-auto cursor-pointer leading-tight"
              >
                AGENDAR TRÊS SESSÕES GRÁTIS
              </button>
              <div className="flex items-center justify-center sm:justify-start gap-2 text-xs sm:text-sm text-gray-600">
                <i className="ri-time-line text-[#E91E63] flex-shrink-0"></i>
                <span>Vagas limitadas para esta semana</span>
              </div>
            </div>
          </div>

          {/* Right Column - Before/After Gallery */}
          <div className="relative lg:order-last order-first">
            <BeforeAfterGallery />
          </div>
        </div>
      </div>
    </section>
  );
}
